<template>
  <AppPageFrame showHeader>
    <div v-if="sessionState.session && !chromeless" class="p-4 full-width">
      <h1 class="welcomeBanner">Welcome back, {{sessionState.session.user.profile.firstName}}!</h1>
    </div>

    <div v-if="sessionState.session && !chromeless" class="p-5 full-width">
      <ApplicationStatusPanel />
    </div>
    
    <div v-if="carouselOffers.length > 0" class="p-4 mb-5 full-width">
      <h1>Featured Offers</h1>
      <h2 class="mb-4">Curated offers from Mini City partners.</h2>

      <OffersCarousel :offers="carouselOffers" context="home/carousel"/>
    </div>

    <OffersCategory class="p-4" title="Recommended Resources" description="Here are some helpful resources based on your interests and needs." :offers="featuredOffers" context="home/featured" viewAllLink="/offers" />
  </AppPageFrame>

</template>

<script lang="ts" setup>

import OffersCarousel from '@/features/partnerOffers/OffersCarousel.vue';
import OffersCategory from '@/features/partnerOffers/OffersCategory.vue';
import { onMounted, ref } from 'vue';
import { getHomePageOffers, logImpressions } from '@/features/partnerOffers/api';
import { PartnerOffer } from '@/features/partnerOffers/model';
import ApplicationStatusPanel from '@/features/applicationStatus/ApplicationStatusPanel.vue';

import { chromeless, sessionState, startNewEngagement } from "@/core/session";

const carouselOffers = ref<PartnerOffer[]>([]);
const featuredOffers = ref<PartnerOffer[]>([]);

onMounted(() => {
  startNewEngagement();
  
  getHomePageOffers().
    then(offers => {
      carouselOffers.value = offers.carouselOffers;
      featuredOffers.value = offers.featuredOffers;

      logImpressions("home/carousel", offers.carouselOffers);
      logImpressions("home/featured", offers.featuredOffers);
    });
});

</script>

<style scoped>

.welcomeBanner {
  font-size: 2.5em;
  font-weight: normal;
  color: #0C4E58;
  text-align: center;
}
</style>
